import { Dialog, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material'

type Props = {
  open: boolean
  onClose: ()=> void
  message: React.ReactNode
  ok_text: string
  action?: ()=> void
  variant?: 'outlined' | 'contained' | 'text'
}
const InfoDialog: React.FC<Props> = ({open, onClose, message, ok_text, action, variant = 'text'}) => {
  return <Dialog
    open={open}
    onClose={onClose}
  >
    <DialogContent>
      {typeof message === 'string' ?
        <DialogContentText sx={{whiteSpace: 'pre-wrap'}}>
          {message}
        </DialogContentText>
      :
        message
      }
    </DialogContent>
    <DialogActions>
      <Button
        color='primary'
        variant={variant}
        fullWidth
        onClick={action || onClose}
      >
        {ok_text}
      </Button>
    </DialogActions>
  </Dialog>
}
export default InfoDialog